import React from 'react';
import Header from '../components/Header';
import HeroCarousel from '../components/HeroCarousel';
import AboutSection from '../components/AboutSection';
import ProductCategories from '../components/ProductCategories';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <HeroCarousel />
        <AboutSection />
        <ProductCategories />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
